/* Built from _three_bears/book.json by build-book-data.cjs. Do not edit by hand. */
window.THREE_BEARS_BOOK = {
  "title": "{name} and the Three Bears",
  "shortTitle": "The Three Bears",
  "pages": 34,
  "trim": "8.5 × 11 in hardcover",
  "allow_baby": true,
  "pronouns": {
    "boy": {
      "he": "he",
      "He": "He",
      "his": "his",
      "His": "His",
      "him": "him",
      "himself": "himself"
    },
    "girl": {
      "he": "she",
      "He": "She",
      "his": "her",
      "His": "Her",
      "him": "her",
      "himself": "herself"
    }
  },
  "fonts": {
    "story": "Fraunces Soft Text 500, italics for emphasis",
    "display": "Cabin Sketch 700"
  },
  "colors": {
    "navy": "#17233f",
    "cream": "#f9efdb",
    "red": "#b5281c"
  },
  "pageOrder": [
    "cover",
    "p01 title page (right-hand)",
    "s01 spread",
    "s02 spread",
    "s03 spread",
    "s04 spread",
    "s05 spread",
    "s06 spread",
    "s07 spread",
    "s08 spread",
    "s09 spread",
    "s10 spread",
    "s11 spread",
    "s12 spread",
    "s13 spread",
    "s14 spread",
    "s15 spread",
    "s16 spread",
    "last page (left-hand)"
  ],
  "titlePage": {
    "lines": [
      "{name}",
      "and the Three Bears",
      "Made especially for {name}",
      "<dedication, optional, <= 3 lines>",
      "<sign-off, optional>"
    ],
    "note": "no author on the title page; the child skips across a meadow in the lower half (pb3-ph-p01.jpg)"
  },
  "lastPage": {
    "lines": [
      "The End",
      "<honey jar art>",
      "Want to make one for someone else? Go to pediment.com.",
      "Copyright © 2026 Pediment Publishing • All Rights Reserved … Personalized edition for {name}. Published by Pediment Publishing, Vancouver, WA"
    ],
    "note": "no author"
  },
  "cover": {
    "title": "{name}",
    "subtitle": "and the Three Bears",
    "style": "white Cabin Sketch, no backing, centred in the top sky; the name shrinks to fit long names",
    "back": "no text",
    "spine": "{NAME} AND THE THREE BEARS + Pediment logo"
  },
  "spreads": [
    {
      "id": "s01",
      "label": "Into the wood",
      "hasChild": true,
      "paragraphs": [
        "{N} lived at the edge of a great green wood.",
        "One morning a bright blue butterfly floated past {N}’s nose.",
        "“Just a little way,” said {N}, and followed it into the trees."
      ],
      "words": {
        "page": "R",
        "left_cqw": 17.823529411764703,
        "top_pct": 4.181818181818182,
        "width_cqw": 42.35294117647059,
        "size_cqw": 2.287581699346405,
        "ink": "#17233f"
      },
      "swapBoxMasterPx": {
        "left": 621,
        "top": 481,
        "width": 812,
        "height": 1199
      }
    },
    {
      "id": "s02",
      "label": "Lost",
      "hasChild": true,
      "paragraphs": [
        "The path twisted this way and that. The trees grew taller and taller.",
        "Then the butterfly was gone, and {N} did not know the way home."
      ],
      "words": {
        "page": "L",
        "left_cqw": 33.235294117647065,
        "top_pct": 9.090909090909092,
        "width_cqw": 45.294117647058826,
        "size_cqw": 2.287581699346405,
        "ink": "#17233f"
      },
      "swapBoxMasterPx": {
        "left": 2346,
        "top": 316,
        "width": 761,
        "height": 1952
      }
    },
    {
      "id": "s03",
      "label": "The bears go walking",
      "hasChild": false,
      "paragraphs": [
        "Not far away, in a little cottage, Mama Bear set out three bowls of porridge.",
        "“Too hot to eat,” said Papa Bear. “Let’s take a walk while it cools.”",
        "And off they went."
      ],
      "words": {
        "page": "L",
        "left_cqw": 18.823529411764707,
        "top_pct": 4.545454545454546,
        "width_cqw": 67.94117647058823,
        "size_cqw": 2.287581699346405,
        "ink": "#17233f"
      },
      "swapBoxMasterPx": null
    },
    {
      "id": "s04",
      "label": "Grumble, rumble",
      "hasChild": true,
      "paragraphs": [
        "{N} walked and walked. {Her} legs grew tired, and {her} tummy began to rumble.",
        "Grumble, rumble, grumble."
      ],
      "words": {
        "page": "R",
        "left_cqw": 20.294117647058822,
        "top_pct": 13.636363636363635,
        "width_cqw": 55.88235294117647,
        "size_cqw": 2.287581699346405,
        "ink": "#17233f"
      },
      "swapBoxMasterPx": {
        "left": 671,
        "top": 208,
        "width": 532,
        "height": 1401
      }
    },
    {
      "id": "s05",
      "label": "The little cottage",
      "hasChild": true,
      "paragraphs": [
        "Then, between the trees, {N} spotted a little cottage with a bright red door.",
        "Sniff, sniff. Warm porridge!",
        "{N} pushed open the door and walked right in.",
        "“I’ll just try a little,” said {N}."
      ],
      "words": {
        "page": "R",
        "left_cqw": 25.76470588235294,
        "top_pct": 12.727272727272727,
        "width_cqw": 41.17647058823529,
        "size_cqw": 2.287581699346405,
        "ink": "#17233f"
      },
      "swapBoxMasterPx": {
        "left": 449,
        "top": 546,
        "width": 650,
        "height": 1556
      }
    },
    {
      "id": "s06",
      "label": "Three bowls",
      "hasChild": true,
      "paragraphs": [
        "On the table were three bowls.",
        "The first was too hot.\nThe second was too cold.\nBut the third was just right!",
        "And {N} ate it all up."
      ],
      "words": {
        "page": "L",
        "left_cqw": 26.764705882352942,
        "top_pct": 4.545454545454546,
        "width_cqw": 42.35294117647059,
        "size_cqw": 2.287581699346405,
        "ink": "#17233f"
      },
      "swapBoxMasterPx": {
        "left": 2581,
        "top": 226,
        "width": 893,
        "height": 1834
      }
    },
    {
      "id": "s07",
      "label": "A nice sit-down",
      "hasChild": true,
      "paragraphs": [
        "{N} patted {her} round, full tummy.",
        "“Mmm,” thought {N}. “Now I need a nice sit-down.”",
        "From the next room came the warm glow of a crackling fire."
      ],
      "words": {
        "page": "R",
        "left_cqw": 18.294117647058822,
        "top_pct": 4.545454545454546,
        "width_cqw": 35.294117647058826,
        "size_cqw": 2.287581699346405,
        "ink": "#17233f"
      },
      "swapBoxMasterPx": {
        "left": 389,
        "top": 500,
        "width": 762,
        "height": 1390
      }
    },
    {
      "id": "s08",
      "label": "Three chairs",
      "hasChild": true,
      "paragraphs": [
        "By the fire were three chairs.",
        "The first was too hard.\nThe second was too squishy.\nBut the third was just right!",
        "Until… wobble, wobble, crack!"
      ],
      "words": {
        "page": "R",
        "left_cqw": 33.588235294117645,
        "top_pct": 4.545454545454546,
        "width_cqw": 35.294117647058826,
        "size_cqw": 2.287581699346405,
        "ink": "#17233f"
      },
      "swapBoxMasterPx": {
        "left": 2519,
        "top": 960,
        "width": 599,
        "height": 775
      }
    },
    {
      "id": "s09",
      "label": "Time for a nap",
      "hasChild": true,
      "paragraphs": [
        "{N} picked {himself} up off the floor. The fire was so warm, and {her} eyes grew heavy.",
        "{N} gave a great big yawn.",
        "“Time for a nap,” {she} thought, and through the next door {she} went, one sleepy step at a time."
      ],
      "words": {
        "page": "L",
        "left_cqw": 42.05882352941177,
        "top_pct": 4.545454545454546,
        "width_cqw": 38.8235294117647,
        "size_cqw": 2.287581699346405,
        "ink": "#17233f"
      },
      "swapBoxMasterPx": {
        "left": 2578,
        "top": 490,
        "width": 563,
        "height": 1437
      }
    },
    {
      "id": "s10",
      "label": "Three beds",
      "hasChild": true,
      "paragraphs": [
        "In the next room were three beds.",
        "The first was too lumpy.\nThe second was too bouncy.\nBut the third was just right!",
        "{N} snuggled in and fell fast asleep."
      ],
      "words": {
        "page": "R",
        "left_cqw": 47.705882352941174,
        "top_pct": 4.545454545454546,
        "width_cqw": 42.35294117647059,
        "size_cqw": 2.287581699346405,
        "ink": "#17233f"
      },
      "swapBoxMasterPx": {
        "left": 2519,
        "top": 1012,
        "width": 793,
        "height": 658
      }
    },
    {
      "id": "s11",
      "label": "Who ate my porridge?",
      "hasChild": false,
      "paragraphs": [
        "Home came the bears.",
        "“Someone’s been eating my porridge,” growled Papa Bear.",
        "“Someone’s been eating my porridge,” said Mama Bear.",
        "“Someone’s been eating my porridge,” squeaked Baby Bear, “and they ate it all up!”"
      ],
      "words": {
        "page": "L",
        "left_cqw": 8.117647058823529,
        "top_pct": 5.818181818181818,
        "width_cqw": 70.58823529411765,
        "size_cqw": 2.287581699346405,
        "ink": "#17233f"
      },
      "swapBoxMasterPx": null
    },
    {
      "id": "s12",
      "label": "Who sat in my chair?",
      "hasChild": false,
      "paragraphs": [
        "The three bears marched into the family room.",
        "“Someone’s been sitting in my chair,” growled Papa Bear.",
        "“Someone’s been sitting in my chair,” said Mama Bear.",
        "“Someone’s been sitting in my chair,” said Baby Bear, “and they broke it!”"
      ],
      "words": {
        "page": "R",
        "left_cqw": 21.058823529411764,
        "top_pct": 5.545454545454545,
        "width_cqw": 34.411764705882355,
        "size_cqw": 2.287581699346405,
        "ink": "#17233f"
      },
      "swapBoxMasterPx": null
    },
    {
      "id": "s13",
      "label": "There {she} is!",
      "hasChild": true,
      "paragraphs": [
        "Into the bedroom they stomped.",
        "“Someone’s been sleeping in my bed,” said Papa Bear.",
        "“Someone’s been sleeping in my bed,” said Mama Bear.",
        "“Someone’s been sleeping in my bed,” said Baby Bear, “and there {she} is!”"
      ],
      "words": {
        "page": "R",
        "left_cqw": 48.88235294117647,
        "top_pct": 4.545454545454546,
        "width_cqw": 42.35294117647059,
        "size_cqw": 2.287581699346405,
        "ink": "#17233f"
      },
      "swapBoxMasterPx": {
        "left": 2519,
        "top": 1012,
        "width": 793,
        "height": 658
      }
    },
    {
      "id": "s14",
      "label": "Three big, cross bears",
      "hasChild": true,
      "paragraphs": [
        "{N} yawned, stretched, and opened {her} eyes.",
        "There stood three bears. Three big bears. Three big, cross bears, staring right at {him}.",
        "“Aaaaah!” yelled {N}.\n“Aaaaah!” yelled the bears.",
        "And {N} scrambled out the window as fast as {she} could go."
      ],
      "words": {
        "page": "L",
        "left_cqw": 42.05882352941177,
        "top_pct": 7.272727272727273,
        "width_cqw": 38.8235294117647,
        "size_cqw": 2.287581699346405,
        "ink": "#17233f"
      },
      "swapBoxMasterPx": {
        "left": 2202,
        "top": 963,
        "width": 1135,
        "height": 1067
      }
    },
    {
      "id": "s15",
      "label": "Thump, thump, thump",
      "hasChild": true,
      "paragraphs": [
        "{N} ran all the way home, heart going thump, thump, thump, and did not stop until {she} was safe at {her} own garden gate."
      ],
      "words": {
        "page": "L",
        "left_cqw": 55.76470588235294,
        "top_pct": 8.363636363636363,
        "width_cqw": 27.999999999999996,
        "size_cqw": 2.287581699346405,
        "ink": "#17233f"
      },
      "swapBoxMasterPx": {
        "left": 975,
        "top": 1026,
        "width": 402,
        "height": 814
      }
    },
    {
      "id": "s16",
      "label": "Never again",
      "hasChild": false,
      "paragraphs": [
        "That night, the three bears sat down to three new bowls of porridge.",
        "And they never saw {N} again."
      ],
      "words": {
        "page": "R",
        "left_cqw": 19.294117647058822,
        "top_pct": 4.454545454545455,
        "width_cqw": 58.82352941176471,
        "size_cqw": 2.287581699346405,
        "ink": "#17233f"
      },
      "swapBoxMasterPx": null
    }
  ],
  "id": "three-bears",
  "copy": {
    "photoPill": "Add the child’s photo",
    "cropButton": "Crop this photo",
    "drawButton": "Yes, draw",
    "redrawButton": "Draw again"
  },
  "demo": {
    "compose": true,
    "master_px": [
      3584,
      2304
    ],
    "title_crop": 0.3,
    "samples": [
      "guide-good",
      "guide-good",
      "guide-good",
      "guide-good"
    ],
    "examples": {
      "boy": "danny",
      "girl": "danny"
    }
  },
  "maxName": 40,
  "headerTitle": "The Three Bears",
  "titleTemplate": "{N} and the Three Bears",
  "ordering": {
    "message": "This book isn't on sale yet, so nothing was added to your cart."
  },
  "builderPages": [
    {
      "id": "cover",
      "art": "ph-cover",
      "box": [
        14.38,
        39.68,
        84.23,
        100
      ]
    },
    {
      "id": "p01",
      "art": "ph-p01",
      "box": [
        29.19,
        35.85,
        70.26,
        86.59
      ]
    },
    {
      "id": "p02-03",
      "spreadId": "s01",
      "art": "ph-s01",
      "label": "Into the wood",
      "hasChild": true,
      "box": [
        17.33,
        20.88,
        39.98,
        72.92
      ],
      "swap": {
        "left": 621,
        "top": 481,
        "width": 812,
        "height": 1199
      },
      "text": [
        {
          "side": "R",
          "el": {
            "x": 109.08,
            "y": 33.12,
            "w": 259.2,
            "size": 14,
            "lead": 19.88,
            "font": "story",
            "color": "#1e2a3f",
            "weight": 500,
            "align": "left",
            "paras": [
              {
                "text": "{N} lived at the edge of a great green wood.",
                "gap": 9
              },
              {
                "text": "One morning a bright blue butterfly floated past {N}’s nose.",
                "gap": 9
              },
              {
                "text": "“Just a little way,” said {N}, and followed it into the trees.",
                "gap": 0
              }
            ],
            "balance": true
          }
        }
      ]
    },
    {
      "id": "p04-05",
      "spreadId": "s02",
      "art": "ph-s02",
      "label": "Lost",
      "hasChild": true,
      "box": [
        65.46,
        13.72,
        86.69,
        98.44
      ],
      "swap": {
        "left": 2346,
        "top": 316,
        "width": 761,
        "height": 1952
      },
      "text": [
        {
          "side": "L",
          "el": {
            "x": 203.4,
            "y": 72,
            "w": 277.2,
            "size": 14,
            "lead": 19.88,
            "font": "story",
            "color": "#1e2a3f",
            "weight": 500,
            "align": "left",
            "paras": [
              {
                "text": "The path twisted this way and that. The trees grew taller and taller.",
                "gap": 9
              },
              {
                "text": "Then the butterfly was gone, and {N} did not know the way home.",
                "gap": 0
              }
            ],
            "balance": true
          }
        }
      ]
    },
    {
      "id": "p06-07",
      "spreadId": "s03",
      "art": "ph-s03",
      "label": "The bears go walking",
      "hasChild": false,
      "box": [
        25,
        35,
        75,
        90
      ],
      "swap": null,
      "text": [
        {
          "side": "L",
          "el": {
            "x": 115.2,
            "y": 36,
            "w": 415.8,
            "size": 14,
            "lead": 19.88,
            "font": "story",
            "color": "#1e2a3f",
            "weight": 500,
            "align": "left",
            "paras": [
              {
                "text": "Not far away, in a little cottage, Mama Bear set out three bowls of porridge.",
                "gap": 9
              },
              {
                "text": "“Too hot to eat,” said Papa Bear. “Let’s take a walk while it cools.”",
                "gap": 9
              },
              {
                "text": "And off they went.",
                "gap": 0
              }
            ],
            "balance": true
          }
        }
      ]
    },
    {
      "id": "p08-09",
      "spreadId": "s04",
      "art": "ph-s04",
      "label": "Grumble, rumble",
      "hasChild": true,
      "box": [
        18.72,
        9.03,
        33.57,
        69.84
      ],
      "swap": {
        "left": 671,
        "top": 208,
        "width": 532,
        "height": 1401
      },
      "text": [
        {
          "side": "R",
          "el": {
            "x": 124.2,
            "y": 108,
            "w": 342,
            "size": 14,
            "lead": 19.88,
            "font": "story",
            "color": "#1e2a3f",
            "weight": 500,
            "align": "left",
            "paras": [
              {
                "text": "{N} walked and walked. {Her} legs grew tired, and {her} tummy began to rumble.",
                "gap": 9
              },
              {
                "text": "Grumble, rumble, grumble.",
                "gap": 0
              }
            ],
            "balance": true
          }
        }
      ]
    },
    {
      "id": "p10-11",
      "spreadId": "s05",
      "art": "ph-s05",
      "label": "The little cottage",
      "hasChild": true,
      "box": [
        12.53,
        23.7,
        30.66,
        91.23
      ],
      "swap": {
        "left": 449,
        "top": 546,
        "width": 650,
        "height": 1556
      },
      "text": [
        {
          "side": "R",
          "el": {
            "x": 157.68,
            "y": 100.8,
            "w": 252,
            "size": 14,
            "lead": 19.88,
            "font": "story",
            "color": "#1e2a3f",
            "weight": 500,
            "align": "left",
            "paras": [
              {
                "text": "Then, between the trees, {N} spotted a little cottage with a bright red door.",
                "gap": 9
              },
              {
                "text": "Sniff, sniff. Warm porridge!",
                "gap": 9
              },
              {
                "text": "{N} pushed open the door and walked right in.",
                "gap": 9
              },
              {
                "text": "“I’ll just try a little,” said {N}.",
                "gap": 0
              }
            ],
            "balance": true
          }
        }
      ]
    },
    {
      "id": "p12-13",
      "spreadId": "s06",
      "art": "ph-s06",
      "label": "Three bowls",
      "hasChild": true,
      "box": [
        72.01,
        9.81,
        96.93,
        89.41
      ],
      "swap": {
        "left": 2581,
        "top": 226,
        "width": 893,
        "height": 1834
      },
      "text": [
        {
          "side": "L",
          "el": {
            "x": 163.8,
            "y": 36,
            "w": 259.2,
            "size": 14,
            "lead": 19.88,
            "font": "story",
            "color": "#1e2a3f",
            "weight": 500,
            "align": "left",
            "paras": [
              {
                "text": "On the table were three bowls.",
                "gap": 9
              },
              {
                "text": "The first was too hot.\nThe second was too cold.\nBut the third was just right!",
                "gap": 9
              },
              {
                "text": "And {N} ate it all up.",
                "gap": 0
              }
            ],
            "balance": true
          }
        }
      ]
    },
    {
      "id": "p14-15",
      "spreadId": "s07",
      "art": "ph-s07",
      "label": "A nice sit-down",
      "hasChild": true,
      "box": [
        10.85,
        21.7,
        32.11,
        82.03
      ],
      "swap": {
        "left": 389,
        "top": 500,
        "width": 762,
        "height": 1390
      },
      "text": [
        {
          "side": "R",
          "el": {
            "x": 111.96,
            "y": 36,
            "w": 216,
            "size": 14,
            "lead": 19.88,
            "font": "story",
            "color": "#1e2a3f",
            "weight": 500,
            "align": "left",
            "paras": [
              {
                "text": "{N} patted {her} round, full tummy.",
                "gap": 9
              },
              {
                "text": "“Mmm,” thought {N}. “Now I need a nice sit-down.”",
                "gap": 9
              },
              {
                "text": "From the next room came the warm glow of a crackling fire.",
                "gap": 0
              }
            ],
            "balance": true
          }
        }
      ]
    },
    {
      "id": "p16-17",
      "spreadId": "s08",
      "art": "ph-s08",
      "label": "Three chairs",
      "hasChild": true,
      "box": [
        70.28,
        41.67,
        87,
        75.3
      ],
      "swap": {
        "left": 2519,
        "top": 960,
        "width": 599,
        "height": 775
      },
      "text": [
        {
          "side": "R",
          "el": {
            "x": 205.56,
            "y": 36,
            "w": 216,
            "size": 14,
            "lead": 19.88,
            "font": "story",
            "color": "#1e2a3f",
            "weight": 500,
            "align": "left",
            "paras": [
              {
                "text": "By the fire were three chairs.",
                "gap": 9
              },
              {
                "text": "The first was too hard.\nThe second was too squishy.\nBut the third was just right!",
                "gap": 9
              },
              {
                "text": "Until… wobble, wobble, crack!",
                "gap": 0
              }
            ],
            "balance": true
          }
        }
      ]
    },
    {
      "id": "p18-19",
      "spreadId": "s09",
      "art": "ph-s09",
      "label": "Time for a nap",
      "hasChild": true,
      "box": [
        71.93,
        21.27,
        87.64,
        83.64
      ],
      "swap": {
        "left": 2578,
        "top": 490,
        "width": 563,
        "height": 1437
      },
      "text": [
        {
          "side": "L",
          "el": {
            "x": 257.4,
            "y": 36,
            "w": 237.6,
            "size": 14,
            "lead": 19.88,
            "font": "story",
            "color": "#1e2a3f",
            "weight": 500,
            "align": "left",
            "paras": [
              {
                "text": "{N} picked {himself} up off the floor. The fire was so warm, and {her} eyes grew heavy.",
                "gap": 9
              },
              {
                "text": "{N} gave a great big yawn.",
                "gap": 9
              },
              {
                "text": "“Time for a nap,” {she} thought, and through the next door {she} went, one sleepy step at a time.",
                "gap": 0
              }
            ],
            "balance": true
          }
        }
      ]
    },
    {
      "id": "p20-21",
      "spreadId": "s10",
      "art": "ph-s10",
      "label": "Three beds",
      "hasChild": true,
      "box": [
        70.28,
        43.92,
        92.41,
        72.48
      ],
      "swap": {
        "left": 2519,
        "top": 1012,
        "width": 793,
        "height": 658
      },
      "text": [
        {
          "side": "R",
          "el": {
            "x": 291.96,
            "y": 36,
            "w": 259.2,
            "size": 14,
            "lead": 19.88,
            "font": "story",
            "color": "#1e2a3f",
            "weight": 500,
            "align": "left",
            "paras": [
              {
                "text": "In the next room were three beds.",
                "gap": 9
              },
              {
                "text": "The first was too lumpy.\nThe second was too bouncy.\nBut the third was just right!",
                "gap": 9
              },
              {
                "text": "{N} snuggled in and fell fast asleep.",
                "gap": 0
              }
            ],
            "balance": true
          }
        }
      ]
    },
    {
      "id": "p22-23",
      "spreadId": "s11",
      "art": "ph-s11",
      "label": "Who ate my porridge?",
      "hasChild": false,
      "box": [
        25,
        35,
        75,
        90
      ],
      "swap": null,
      "text": [
        {
          "side": "L",
          "el": {
            "x": 49.68,
            "y": 46.08,
            "w": 432,
            "size": 14,
            "lead": 19.88,
            "font": "story",
            "color": "#1e2a3f",
            "weight": 500,
            "align": "left",
            "paras": [
              {
                "text": "Home came the bears.",
                "gap": 9
              },
              {
                "text": "“Someone’s been eating my porridge,” growled Papa Bear.",
                "gap": 9
              },
              {
                "text": "“Someone’s been eating my porridge,” said Mama Bear.",
                "gap": 9
              },
              {
                "text": "“Someone’s been eating my porridge,” squeaked Baby Bear, “and they ate it all up!”",
                "gap": 0
              }
            ],
            "balance": true
          }
        }
      ]
    },
    {
      "id": "p24-25",
      "spreadId": "s12",
      "art": "ph-s12",
      "label": "Who sat in my chair?",
      "hasChild": false,
      "box": [
        25,
        35,
        75,
        90
      ],
      "swap": null,
      "text": [
        {
          "side": "R",
          "el": {
            "x": 128.88,
            "y": 43.92,
            "w": 210.6,
            "size": 14,
            "lead": 19.88,
            "font": "story",
            "color": "#1e2a3f",
            "weight": 500,
            "align": "left",
            "paras": [
              {
                "text": "The three bears marched into the family room.",
                "gap": 9
              },
              {
                "text": "“Someone’s been sitting in my chair,” growled Papa Bear.",
                "gap": 9
              },
              {
                "text": "“Someone’s been sitting in my chair,” said Mama Bear.",
                "gap": 9
              },
              {
                "text": "“Someone’s been sitting in my chair,” said Baby Bear, “and they broke it!”",
                "gap": 0
              }
            ],
            "balance": true
          }
        }
      ]
    },
    {
      "id": "p26-27",
      "spreadId": "s13",
      "art": "ph-s13",
      "label": "There {she} is!",
      "hasChild": true,
      "box": [
        70.28,
        43.92,
        92.41,
        72.48
      ],
      "swap": {
        "left": 2519,
        "top": 1012,
        "width": 793,
        "height": 658
      },
      "text": [
        {
          "side": "R",
          "el": {
            "x": 299.16,
            "y": 36,
            "w": 259.2,
            "size": 14,
            "lead": 19.88,
            "font": "story",
            "color": "#1e2a3f",
            "weight": 500,
            "align": "left",
            "paras": [
              {
                "text": "Into the bedroom they stomped.",
                "gap": 9
              },
              {
                "text": "“Someone’s been sleeping in my bed,” said Papa Bear.",
                "gap": 9
              },
              {
                "text": "“Someone’s been sleeping in my bed,” said Mama Bear.",
                "gap": 9
              },
              {
                "text": "“Someone’s been sleeping in my bed,” said Baby Bear, “and there {she} is!”",
                "gap": 0
              }
            ],
            "balance": true
          }
        }
      ]
    },
    {
      "id": "p28-29",
      "spreadId": "s14",
      "art": "ph-s14",
      "label": "Three big, cross bears",
      "hasChild": true,
      "box": [
        61.44,
        41.8,
        93.11,
        88.11
      ],
      "swap": {
        "left": 2202,
        "top": 963,
        "width": 1135,
        "height": 1067
      },
      "text": [
        {
          "side": "L",
          "el": {
            "x": 257.4,
            "y": 57.6,
            "w": 237.6,
            "size": 14,
            "lead": 19.88,
            "font": "story",
            "color": "#1e2a3f",
            "weight": 500,
            "align": "left",
            "paras": [
              {
                "text": "{N} yawned, stretched, and opened {her} eyes.",
                "gap": 9
              },
              {
                "text": "There stood three bears. Three big bears. Three big, cross bears, staring right at {him}.",
                "gap": 9
              },
              {
                "text": "“Aaaaah!” yelled {N}.\n“Aaaaah!” yelled the bears.",
                "gap": 9
              },
              {
                "text": "And {N} scrambled out the window as fast as {she} could go.",
                "gap": 0
              }
            ],
            "balance": true
          }
        }
      ]
    },
    {
      "id": "p30-31",
      "spreadId": "s15",
      "art": "ph-s15",
      "label": "Thump, thump, thump",
      "hasChild": true,
      "box": [
        27.2,
        44.53,
        38.42,
        79.86
      ],
      "swap": {
        "left": 975,
        "top": 1026,
        "width": 402,
        "height": 814
      },
      "text": [
        {
          "side": "L",
          "el": {
            "x": 341.28,
            "y": 66.24,
            "w": 171.36,
            "size": 14,
            "lead": 19.88,
            "font": "story",
            "color": "#1e2a3f",
            "weight": 500,
            "align": "left",
            "paras": [
              {
                "text": "{N} ran all the way home, heart going thump, thump, thump, and did not stop until {she} was safe at {her} own garden gate.",
                "gap": 0
              }
            ],
            "balance": true
          }
        }
      ]
    },
    {
      "id": "p32-33",
      "spreadId": "s16",
      "art": "ph-s16",
      "label": "Never again",
      "hasChild": false,
      "box": [
        25,
        35,
        75,
        90
      ],
      "swap": null,
      "text": [
        {
          "side": "R",
          "el": {
            "x": 118.08,
            "y": 35.28,
            "w": 360,
            "size": 14,
            "lead": 19.88,
            "font": "story",
            "color": "#1e2a3f",
            "weight": 500,
            "align": "left",
            "paras": [
              {
                "text": "That night, the three bears sat down to three new bowls of porridge.",
                "gap": 9
              },
              {
                "text": "And they never saw {N} again.",
                "gap": 0
              }
            ],
            "balance": true
          }
        }
      ]
    }
  ],
  "layout": {
    "page_pt": [
      612,
      792
    ],
    "cover_pt": [
      630,
      858.9
    ],
    "cover": {
      "els": [
        {
          "x": 85,
          "y": 44,
          "w": 460,
          "size": 70,
          "lead": 94.5,
          "font": "display",
          "color": "#ffffff",
          "weight": 700,
          "align": "center",
          "paras": [
            {
              "text": "{N}",
              "gap": 0
            }
          ]
        },
        {
          "x": 85,
          "y": 126,
          "w": 460,
          "size": 38,
          "lead": 51.300000000000004,
          "font": "display",
          "color": "#ffffff",
          "weight": 700,
          "align": "center",
          "paras": [
            {
              "text": "and the Three Bears",
              "gap": 0
            }
          ]
        }
      ],
      "fit": {
        "min_ratio": 0.5
      }
    },
    "title": {
      "name": 0,
      "dedication": 3,
      "from": 4,
      "dedication_lines": 3,
      "wrap_slack": 8,
      "name_fit": {
        "width": 478.8,
        "min": 40,
        "step": 0.5
      },
      "els": [
        {
          "x": 66.60000000000001,
          "y": 70,
          "w": 478.8,
          "size": 80,
          "lead": 80,
          "font": "display",
          "color": "#17233f",
          "weight": 700,
          "align": "center",
          "paras": [
            {
              "text": "{N}",
              "gap": 0
            }
          ]
        },
        {
          "x": 66.60000000000001,
          "y": 166.2,
          "w": 478.8,
          "size": 36,
          "lead": 36,
          "font": "display",
          "color": "#17233f",
          "weight": 700,
          "align": "center",
          "paras": [
            {
              "text": "and the Three Bears",
              "gap": 0
            }
          ]
        },
        {
          "x": 66.60000000000001,
          "y": 222,
          "w": 478.8,
          "size": 17,
          "lead": 24.14,
          "font": "story",
          "color": "#17233f",
          "weight": 600,
          "align": "center",
          "paras": [
            {
              "text": "Made especially for {N}",
              "gap": 0
            }
          ],
          "ls": 0.03
        },
        {
          "x": 66.60000000000001,
          "y": 254,
          "w": 478.8,
          "size": 15,
          "lead": 21,
          "font": "story",
          "color": "#17233f",
          "weight": 600,
          "align": "center",
          "paras": [
            {
              "text": "{DED}",
              "gap": 0
            }
          ]
        },
        {
          "x": 66.60000000000001,
          "y": 254,
          "w": 478.8,
          "size": 15,
          "lead": 21,
          "font": "story",
          "color": "#17233f",
          "weight": 500,
          "align": "center",
          "paras": [
            {
              "text": "{FROM}",
              "gap": 0
            }
          ]
        }
      ]
    },
    "back": {
      "art": "ph-last",
      "els": [
        {
          "x": 66.60000000000001,
          "y": 110,
          "w": 478.8,
          "size": 44,
          "lead": 52.8,
          "font": "display",
          "color": "#17233f",
          "weight": 700,
          "align": "center",
          "paras": [
            {
              "text": "The End",
              "gap": 0
            }
          ]
        },
        {
          "x": 66.60000000000001,
          "y": 560,
          "w": 478.8,
          "size": 13,
          "lead": 16.9,
          "font": "story",
          "color": "#17233f",
          "weight": 500,
          "align": "center",
          "paras": [
            {
              "text": "Want to make one for someone else? Go to pediment.com.",
              "gap": 0,
              "href": "https://www.pediment.com",
              "runs": [
                {
                  "text": "Want to make one for someone else? Go to "
                },
                {
                  "text": "pediment.com",
                  "weight": 700,
                  "color": "#b5281c"
                },
                {
                  "text": "."
                }
              ]
            }
          ]
        },
        {
          "x": 79.2,
          "y": 640,
          "w": 453.59999999999997,
          "size": 8,
          "lead": 11.2,
          "font": "legal",
          "color": "#4c5363",
          "weight": 400,
          "align": "center",
          "paras": [
            {
              "text": "{N} and the Three Bears\nCopyright © 2026 Pediment Publishing • All Rights Reserved\nNo part of this book may be reproduced, stored in a retrieval system or transmitted in any form or by any means, electronic, mechanical, photocopying, recording or otherwise without prior written permission of the publisher.\nPersonalized edition for {N}.\nPublished by Pediment Publishing, Vancouver, WA",
              "gap": 0
            }
          ]
        }
      ],
      "caption": "Page 34 · The End"
    }
  }
};
window.BOOK_PAGES = window.THREE_BEARS_BOOK.builderPages;
window.BOOK_LAYOUT = window.THREE_BEARS_BOOK.layout;
window.BOOK_MODEL = window.THREE_BEARS_BOOK;
